import React from "react";
import { connect } from "react-redux";
import { userActions } from "../../redux/_actions";
import axios from "axios";
import severUrl from "../../api";

class Update extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            news: [],
        };
    }

    componentDidMount() {
        fetch(severUrl + `blog/updates/query/`, {
            method: "GET",
            ContentEncoding: "gzip"
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data)
                this.setState({ news: data })
            })
    }

    render() {
        // const { registering } = this.props;
        // const { user, submitted } = this.state;
        return (
            <>
                <p style={{fontWeight:"bold"}}>Recent Activities</p>
                {Array.from(this.state.news).map(({ heading,day , content }) => (
                    <>
                    <br></br> 
                    <h3>{heading}</h3>
                    <p>{day}</p>
                    <p>{content}</p>
                    <br></br> 
                    </>
                ))}
            </>
        );
    }
}

function mapState(state) {
    const { registering } = state.registration;
    return { registering };
}

const actionCreators = {
    register: userActions.register,
};

const connectedRegisterPage = connect(mapState, actionCreators)(Update);
export { connectedRegisterPage as Update };
